/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Declinedeal_Reasons_Portfoliofitissues4Inputs */

const en_coinvestments_declinedeal_reasons_portfoliofitissues4 = /** @type {(inputs: Coinvestments_Declinedeal_Reasons_Portfoliofitissues4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portfolio fit issues`)
};

/**
* | output |
* | --- |
* | "Portfolio fit issues" |
*
* @param {Coinvestments_Declinedeal_Reasons_Portfoliofitissues4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_declinedeal_reasons_portfoliofitissues4 = /** @type {((inputs?: Coinvestments_Declinedeal_Reasons_Portfoliofitissues4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Declinedeal_Reasons_Portfoliofitissues4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_declinedeal_reasons_portfoliofitissues4(inputs)
});
export { coinvestments_declinedeal_reasons_portfoliofitissues4 as "coInvestments_declineDeal_reasons_portfolioFitIssues" }